export function isValidLink(s: string) {
  const validators = [isValidYoutube, isValidRutube, isValidVkVideo];
  for (const validate of validators) {
    const result = validate(s);
    if (result?.status) return result;
  }
  return { status: false };
}

function isValidYoutube(s: string) {
  const m = s.match(/^https:\/\/(www\.)?(youtube\.com\/)(watch\?v=|shorts\/)([^\/\s&]*)(\&.+=.+)?(\/)?$/);
  if(m == null) return null;
  return {
    status: true,
    originUrl: m[2],
    videoType: m[3],
    id: m[4],
    password: null,
    origin: 'YOUTUBE',
  }
}
function isValidRutube(s: string) {
  const m = s.match(/^https:\/\/(www\.)?(rutube\.ru\/)(video\/|shorts\/)(private\/)?([^\/\s]*)(\/\?p=(.+))?(\/)?$/);
  if(m == null) return { status: false };
  return {
    status: true,
    originUrl: m[2],
    videoType: m[3],
    id: m[5],
    password: m[7],
    origin: 'RUTUBE',
  }
}

function isValidVkVideo(s: string) {
  const vkComDirect = s.match(/^https:\/\/(www\.)?(vk\.com\/)(video-?\d+_\d+)(\/)?(\?.*)?$/);
  if (vkComDirect) {
    return {
      status: true,
      originUrl: vkComDirect[2],
      videoType: 'video',
      id: vkComDirect[3].replace('video', ''),
      password: null,
      origin: 'VK_VIDEO',
    };
  }

  const vkComVideos = s.match(/^https:\/\/(www\.)?(vk\.com\/)(videos-?\d+)\?z=(video-?\d+_\d+)(%2F[^&\s]+)?(&.*)?$/);
  if (vkComVideos) {
    return {
      status: true,
      originUrl: vkComVideos[2],
      videoType: vkComVideos[3],
      id: vkComVideos[4].replace('video', ''),
      password: null,
      origin: 'VK_VIDEO',
    };
  }

  const vkVideo = s.match(/^https:\/\/(www\.)?(vkvideo\.ru\/)(@[^\/\s]+\/)?(video-?\d+_\d+)(\/)?(\?.*)?$/);
  if (vkVideo) {
    return {
      status: true,
      originUrl: vkVideo[2],
      videoType: vkVideo[3] ? 'channel-video' : 'video',
      id: vkVideo[4].replace('video', ''),
      password: null,
      origin: 'VK_VIDEO',
    };
  }

  const vkClip = s.match(/^https:\/\/(www\.)?(vkvideo\.ru\/)(clip-?\d+_\d+)(\/)?(\?.*)?$/);
  if (vkClip) {
    return {
      status: true,
      originUrl: vkClip[2],
      videoType: 'clip',
      id: vkClip[3].replace('clip', ''),
      password: null,
      origin: 'VK_VIDEO',
    };
  }

  const vkPlaylistVideo = s.match(/^https:\/\/(www\.)?(vkvideo\.ru\/)(playlist\/-?\d+_\d+\/)(video-?\d+_\d+)(\/)?(\?.*)?$/);
  if (vkPlaylistVideo) {
    return {
      status: true,
      originUrl: vkPlaylistVideo[2],
      videoType: vkPlaylistVideo[3].slice(0, -1),
      id: vkPlaylistVideo[4].replace('video', ''),
      password: null,
      origin: 'VK_VIDEO',
    };
  }

  const vkEmbed = s.match(/^https:\/\/(www\.)?(vk\.com\/)(video_ext\.php)\?oid=(-?\d+)&id=(\d+)&hash=([^&\s]+)(&.*)?$/);
  if (vkEmbed) {
    return {
      status: true,
      originUrl: vkEmbed[2],
      videoType: vkEmbed[3],
      id: `${vkEmbed[4]}_${vkEmbed[5]}`,
      password: vkEmbed[6],
      origin: 'VK_VIDEO',
    };
  }

  const vkMobile = s.match(/^https:\/\/(www\.)?(vk\.com\/)(video)\?z=(video-?\d+_\d+)(%2F[^&\s]+)?(&.*)?$/);
  if (vkMobile) {
    return {
      status: true,
      originUrl: vkMobile[2],
      videoType: vkMobile[3],
      id: vkMobile[4].replace('video', ''),
      password: null,
      origin: 'VK_VIDEO',
    };
  }

  // const vkShort = s.match(/^https:\/\/(vk\.cc\/)([A-Za-z0-9]+)(\/)?(\?.*)?$/);
  // if (vkShort) {
  //   return {
  //     status: true,
  //     originUrl: vkShort[1],
  //     videoType: 'short-link',
  //     id: vkShort[2],
  //     password: null,
  //     origin: 'VK_VIDEO',
  //   };
  // }

  return null;
}
